'use strict';
import React from 'react';
import {useState} from 'react';
import './App.css';

// Mobile Popup
// There are 3 buttons: ambient sounds, bgm, and bg
// on click: disable any other buttons, and then enable selected button
// disabling: remove .-active from toggles and right bar
// how to specify the toggle and the active switch?
// the props can just be 'amb', 'bg', and 'bgm' and put together w string method


const MobilePopup = () => {

    const [clicked, setClicked] = useState('');

    const handleClick = (props) => {
        const iconClass = props;

        const selectedToggle = document.querySelector('.' + iconClass + '-toggle');
        const selectedActive = iconClass + '-active';
        const rightContainer = document.querySelector('.right-container');

        if (clicked == false) {
            selectedToggle.classList.add(selectedActive);
            rightContainer.classList.add(selectedActive);
            setClicked(props);
        } else if (clicked === props){
            selectedToggle.classList.remove(selectedActive);
            rightContainer.classList.remove(selectedActive);
            setClicked('');
        } else {
            let clickedToggle = document.querySelector('.' + clicked + '-toggle');
            let clickedActive = clicked + '-active';
            clickedToggle.classList.remove(clickedActive);
            rightContainer.classList.remove(clickedActive);

            selectedToggle.classList.add(selectedActive);
            rightContainer.classList.add(selectedActive);
            setClicked(props);
        }

    };

    return (
        <div className="mobile-version">
        <button onClick={() => handleClick('amb')}><img src="img/ambience.png" alt="Ambient Sounds icon"></img></button>
        <button onClick={() => handleClick('bgm')}><img src="img/music.png" alt="Background Music icon"></img></button>
        <button onClick={() => handleClick('bg')}><img src="img/picture.png" alt="Backgrounds Icon"></img></button>
    </div>
    );
}

export default MobilePopup;